// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13":"fc46c6a0","168":"afd54f29","819":"ed3c21fa"}[chunkId] + ".chunk.css";
};